import { render, staticRenderFns } from "./HorizontalScroller.vue?vue&type=template&id=36adf6e0&scoped=true&"
import script from "./HorizontalScroller.vue?vue&type=script&lang=js&"
export * from "./HorizontalScroller.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScroller.vue?vue&type=style&index=0&id=36adf6e0&scoped=true&lang=css&"
import style1 from "./HorizontalScroller.vue?vue&type=style&index=1&id=36adf6e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36adf6e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
